module.exports = __webpack_public_path__ + "img/gut_logo.b558c9cc.png";